import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHtml5, faCss3Alt, faJs, faReact, 
    faBootstrap, faNodeJs, 
    faGitAlt, faGithub, faPhp
} from '@fortawesome/free-brands-svg-icons';
import { 
    faServer, 
    faTerminal, 
    faCode, 
} from '@fortawesome/free-solid-svg-icons';
import { SiNextdotjs, SiTailwindcss, SiLaravel, SiPostgresql, SiTypescript, SiMongodb, SiMysql, SiDotnet } from 'react-icons/si';

const SKILL_ICONS = {
    'HTML5':        { type: 'fa', icon: faHtml5 },
    'CSS3':         { type: 'fa', icon: faCss3Alt },
    'JavaScript':   { type: 'fa', icon: faJs },
    'React':        { type: 'fa', icon: faReact },
    'Bootstrap':    { type: 'fa', icon: faBootstrap },
    'Node.js':      { type: 'fa', icon: faNodeJs },
    'PHP':          { type: 'fa', icon: faPhp },
    'Git':          { type: 'fa', icon: faGitAlt },
    'GitHub':       { type: 'fa', icon: faGithub },
    'Express':      { type: 'fa', icon: faServer },
    'Command Line': { type: 'fa', icon: faTerminal },
    'REST APIs':    { type: 'fa', icon: faCode },

    'TypeScript':   { type: 'si', icon: SiTypescript },
    'Next.js':      { type: 'si', icon: SiNextdotjs },
    'Tailwind CSS': { type: 'si', icon: SiTailwindcss },
    'Laravel':      { type: 'si', icon: SiLaravel },
    'PostgreSQL':   { type: 'si', icon: SiPostgresql },
    'MongoDB':      { type: 'si', icon: SiMongodb },
    'MySQL':        { type: 'si', icon: SiMysql },
    'ASP.NET':      { type: 'si', icon: SiDotnet },
};

const Skills = ({ skills }) => {
    const categorizeSkills = (allSkills) => {
        const categories = {
            'LANGUAGES': [],
            'FRONTEND': [],
            'BACKEND': [],
            'TOOLS & OTHERS': []
        };

        allSkills.forEach(skill => {
            switch(skill.category) {
                case 'Frontend':
                    categories['FRONTEND'].push(skill);
                    break;
                case 'Backend':
                    categories['BACKEND'].push(skill);
                    break;
                case 'Database':
                    categories['BACKEND'].push(skill);
                    break;
                case 'Tools':
                    categories['TOOLS & OTHERS'].push(skill);
                    break;
                default:
                    categories['LANGUAGES'].push(skill);
            }
        });

        return categories;
    };

    const categorizedSkills = categorizeSkills(skills);

    const SkillIcon = ({ skill }) => {
        const className = `skill-icon ${skill.name.toLowerCase().replace(/\s+/g, '')}`;
        const entry = SKILL_ICONS[skill.name];

        if (!entry) return <FontAwesomeIcon icon={faCode} className={className} />;

        if (entry.type === 'si') {
            const Icon = entry.icon;
            return <Icon className={className} />;
        }

        return <FontAwesomeIcon icon={entry.icon} className={className} />;
    };

    const SkillCategory = ({ title, skillList }) => (
        <div className="skills-category">
            <h3>{title}</h3>
            <div className="skill-list">
                {skillList.map((skill, index) => (
                    <div key={index} className="skill-item">
                        <SkillIcon skill={skill} />
                        <div className="skill-name">{skill.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <section id="skills" className="skills section">
            <div className="container">
                <h2 className="section-title">Skills</h2>
                <div className="skills-container">
                    {Object.entries(categorizedSkills).map(([category, skills]) => 
                        skills.length > 0 && (
                            <SkillCategory 
                                key={category} 
                                title={category} 
                                skillList={skills} 
                            />
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default Skills;